// extracted by mini-css-extract-plugin
export default {"container":"Job_container__3Uqfr","imgContainer":"Job_imgContainer__jXSXV","topImg":"Job_topImg__ntN3G","vision":"Job_vision__-2WsX","darkvision":"Job_darkvision__5UDDz"};